import React from 'react';

const Government = () => {
  return (
    <div>
      <h1>自治体</h1>
      <p>ここでは、プログラミングやAI、Web開発の学習内容について紹介します。</p>
    </div>
  );
};

export default Government;